/*
 * This file is part of the Det Norske Teatret application.
 *
 * (c) APT AS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React from 'react';
import './Error.scss';

interface ErrorProps {
  children?: string;
}

/**
 * This is the Error component.
 *
 * @author Thomas Sømoen <thomas@apt.no>
 */
function Error({ children = 'Internal Server Error' }: ErrorProps) {
  return (
    <article className="page error-page">
      <h2>500 {children}</h2>
    </article>
  );
}

export default Error;
